import n500 from '@/assets/imgs/500.svg';
import Error from './components/Error';

function Server500(props) {
  return <Error title="500" type="500" imgSrc={n500}></Error>;
}

export default Server500;
